export default "__VITE_ASSET__Sw4$xOlO__"